var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOndoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0884 16.0128C21.1905 15.7066 21.4771 15.5 21.7999 15.5H27.1689C27.6808 15.5 28.0423 16.0015 27.8804 16.4872L26.7094 20H19.7593L20.2593 18.5H20.375V18.153L21.0884 16.0128ZM27.2675 21.5C27.2559 21.5003 27.2443 21.5003 27.2327 21.5H17.55C16.4178 21.5 15.5 22.4178 15.5 23.55V24.75V27H18.0312C19.5328 27 20.75 28.2172 20.75 29.7188C20.75 31.2203 19.5328 32.4375 18.0312 32.4375H15.5V33.95C15.5 35.0822 16.4178 36 17.55 36H28.7937H29.1875H30.5789H33.95C35.0822 36 36 35.0822 36 33.95V23.55C36 22.4178 35.0822 21.5 33.95 21.5H27.2675ZM14 32.4375V31.6875V27.75V27V24.75V23.55V20.25C14 18.4551 15.4551 17 17.25 17H19.1782L19.6654 15.5385C19.9716 14.6197 20.8314 14 21.7999 14H27.1689C28.7046 14 29.789 15.5046 29.3034 16.9615L29.2906 17H30.25C31.9608 17 33.3629 18.3219 33.4905 20H33.95C35.9106 20 37.5 21.5894 37.5 23.55V33.95C37.5 35.9106 35.9106 37.5 33.95 37.5H30.5789H29.1875H28.7937H17.55C15.5894 37.5 14 35.9106 14 33.95V32.4375ZM15.5 30.9375H18.0312C18.7043 30.9375 19.25 30.3918 19.25 29.7188C19.25 29.0457 18.7043 28.5 18.0312 28.5H15.5V30.9375ZM17.55 20C16.7864 20 16.079 20.2411 15.5 20.6514V20.25C15.5 19.2835 16.2835 18.5 17.25 18.5H18.6782L18.1782 20H17.55ZM28.2906 20H31.9823C31.861 19.1519 31.1316 18.5 30.25 18.5H28.7906L28.2906 20Z",
    fill: "#CA1211"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOndoor);
export default __webpack_public_path__ + "static/media/ondoor.e2a1976fe209eaa84e0b7cfd08588c41.svg";
export { ForwardRef as ReactComponent };